import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import NavBar from "../../../components/app/nav-bar/NavBar";
import { NavDataType } from "../../../constants/common";
import { PROVIDER_MENU } from "../../../constants/providerLayout";
import useDisclosure from "../../../hooks/use-disclosure";
// import { logoutUser } from "../../../AuthProvider";
import LogOutModal from "../../../components/LogOutModal";
import { PROVIDER_NAV_OPTIONS } from "../../../constants/admin-layout";
// import HelpSupport from "../../../services/support/HelpSupport";
// import AiAssistant from "../../../components/app/provider/ai-assistant/AiAssistant";
// import AiAssistantFab from "../../../components/app/provider/ai-assistant/AiAssistantFab";

const ProviderPortalLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [anchorElUser, setAnchorElUser] = useState<HTMLElement | null>(null);
  const [activeTab, setActiveTab] = useState<string>(PROVIDER_MENU[0].value);
  const logOutDisclosure = useDisclosure(false);

  useEffect(() => {
    setActiveTab(
      PROVIDER_MENU.find(
        (item) => item.value === location.pathname?.split("/")?.[3]
        // &&
        //   (item.path === location.pathname + location.search ||
        //     item.children?.some(
        //       (child) => child.path === location.pathname + location.search
        //     ))
      )?.value ?? PROVIDER_MENU[1].value
    );
  }, [location.pathname]);

  function handleCloseUserMenu(submenu?: NavDataType) {
    submenu?.path && navigate(submenu.path);
    setAnchorElUser(null);
  }

  function onClickProfileData(profileData: NavDataType) {
    profileData.path && navigate(profileData.path);

    if (profileData.value === "log_out") {
      logOutDisclosure.open();
    }
  }

  function handleTabClick(
    menu: NavDataType,
    event: React.MouseEvent<HTMLElement>
  ) {
    menu?.children &&
      setAnchorElUser((prevAnchorEl) =>
        prevAnchorEl ? null : event.currentTarget
      );

    menu.path && navigate(menu.path);
  }

  return (
    <Box height={"100vh"} overflow="hidden">
      <NavBar
        view="provider"
        navOptions={PROVIDER_MENU}
        anchorElUser={anchorElUser}
        active={activeTab}
        handleCloseUserMenu={handleCloseUserMenu}
        onClickMenuItem={handleTabClick}
        profileData={PROVIDER_NAV_OPTIONS}
        handleProfileClick={onClickProfileData}
      />

      <Box maxWidth={"100%"} minHeight={"100%"}>
        <LogOutModal disclosureHost={logOutDisclosure} />
        <Outlet />
        {/* <HelpSupport /> */}
        {/* <AiAssistantFab /> */}
        {/* <AiAssistant /> */}
      </Box>
    </Box>
  );
};

export default ProviderPortalLayout;
